import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d5fee3b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "table-block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormField = _resolveComponent("FormField")!
  const _component_CategoryTable = _resolveComponent("CategoryTable")!
  const _component_NorthIcon = _resolveComponent("NorthIcon")!
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_SouthIcon = _resolveComponent("SouthIcon")!
  const _component_DeleteIcon = _resolveComponent("DeleteIcon")!
  const _component_BaseTable = _resolveComponent("BaseTable")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_BaseTable, {
        "column-defs": _ctx.columnDefs,
        "row-data": _ctx.cross,
        loading: false,
        enumerable: true
      }, {
        "cell(name)": _withCtx(({ row }) => [
          _createVNode(_component_FormField, {
            value: row.name,
            "onUpdate:value": ($event: any) => ((row.name) = $event),
            clearable: true,
            name: "operator",
            class: "margin-0"
          }, null, 8, ["value", "onUpdate:value"])
        ]),
        "cell(categories)": _withCtx(({ row }) => [
          _createVNode(_component_CategoryTable, {
            categories: row.items,
            "category-option-list": _ctx.categoryOptionList
          }, null, 8, ["categories", "category-option-list"])
        ]),
        "cell(actions)": _withCtx(({ rowIndex }) => [
          _createVNode(_component_BaseButton, {
            variant: "icon",
            title: "Move up",
            disabled: rowIndex === 0,
            onClick: ($event: any) => (_ctx.handleClick(_ctx.cross, rowIndex, 'up'))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_NorthIcon)
            ]),
            _: 2
          }, 1032, ["disabled", "onClick"]),
          _createVNode(_component_BaseButton, {
            variant: "icon",
            title: "Move down",
            disabled: rowIndex === _ctx.cross.length - 1,
            onClick: ($event: any) => (_ctx.handleClick(_ctx.cross, rowIndex, 'down'))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_SouthIcon)
            ]),
            _: 2
          }, 1032, ["disabled", "onClick"]),
          _createVNode(_component_BaseButton, {
            variant: "icon",
            title: "Delete",
            onClick: ($event: any) => (_ctx.removeField(rowIndex))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_DeleteIcon)
            ]),
            _: 2
          }, 1032, ["onClick"])
        ]),
        _: 1
      }, 8, ["column-defs", "row-data"]),
      _createElementVNode("div", null, [
        _createVNode(_component_BaseButton, {
          variant: "outline-primary",
          title: "Add option",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addElement(_ctx.cross)))
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Добавить навигацию ")
          ]),
          _: 1
        })
      ])
    ])
  ]))
}